
"use strict";

import getSelectedOptions from "../common/get-selected-options";

export default sb => {
    let deviceSelect;

    const fetchDevices = function fetchDevices() {
        const data = {
            type: 'open'
        };
        return sb.postApi("/tv-player-report/get-devices", data).then(devices => {
            sb.notify({ type: "devicesLoaded", data: devices });

            return devices;
        });
    };

    const populateDevicesSelect = function populateDevicesSelect(devices) {
        const options = devices.filter(
            device => (device.name.toLowerCase() !== 'all') //Skip the 'all' option
        ).map(device => {
            return `<option selected value="${device.id}">${device.name}</option>`;
        }).join("\n");

        sb.append(deviceSelect, options);
        onDevicesSelectionChange(); // We've added devices selected

        return devices;
    };

    const onDevicesSelectionChange = function onDevicesSelectionChange() {
        sb.notify({
            type: "devicesSelectionChanged",
            data: [].map.call(
                getSelectedOptions(deviceSelect[0]),
                option => option.value
            )
        });
    };

    return {
        init() {
            deviceSelect = sb.find("#device");
            sb.addEvent(deviceSelect[0], "change", onDevicesSelectionChange);

            fetchDevices().then(populateDevicesSelect);
        },
        destroy() {
            sb.removeEvent(deviceSelect[0], "change", onDevicesSelectionChange);
            deviceSelect = null;
        }
    }
};
